import axios from 'axios';

export const createUser = async (queryParams) => {
  const { data } = await axios.post('/users/create', queryParams);

  return data;
};
